import Vue from 'vue'
import VueRouter from 'vue-router'
import QRCodes from '../views/QRCodes'
import { Auth } from 'aws-amplify'
import Unauthorized from '../views/Unauthorized'

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: QRCodes,
            meta: {
                auth: true
            }
        },
        {
            path: '/qr-codes',
            name: 'QRCodes',
            component: QRCodes,
            meta: {
                auth: true
            }
        },
        {
            path: '/unauthorized',
            name: 'Unauthorized',
            component: Unauthorized
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (!to.meta.auth || process.env.NODE_ENV === 'test') {
        next()
    } else {
        Auth.currentAuthenticatedUser().then(() => {
            next()
        }).catch(() => {
            next({ name: 'Unauthorized' })
        })
    }
})

export default router
